import React, { useEffect, useState } from "react";
import styles from "./meetings.module.scss";

const MeetingSettings = ({ token }) => {

  useEffect(() => {
  }, []);
  return (
    <div className={styles.ekycWrapper}>
        <h5>Settings</h5>
    </div>
  );
};

export default MeetingSettings;